import LoadingSpinner from 'components/LoadingSpinner';
import type { FC } from 'react';
import { EditorSteps } from 'ui/editor/dataStream/TileEditor/constants';
import type { StepWithCondition } from 'ui/editor/dataStream/TileEditor/hooks/useTileEditorSteps';
import type { ScopeState } from 'ui/editor/dataStream/TileEditor/state/scope/ScopeState';
import { DataStreamObjectsSublabel } from 'ui/editor/dataStream/TileEditor/steps/stepDefinitions/objectsStep/DataStreamObjectsSublabel';
import { ObjectsStep } from 'ui/editor/dataStream/TileEditor/steps/stepDefinitions/objectsStep/ObjectsStep';

interface PluginImportObjectsStepSublabelProps {
    hasDataStream: boolean;
    storeCurrentStep: EditorSteps | undefined;
    datasetConfigScope: any;
    scopeState: ScopeState;
    workspaceId: string;
}

interface UsePluginImportObjectsStepParameters {
    hasDataStream: boolean;
    storeCurrentStep: EditorSteps | undefined;
    datasetConfigScope: any;
    scopeState: ScopeState;
    workspaceId: string;
}

const PluginImportObjectsStepSublabel: FC<PluginImportObjectsStepSublabelProps> = ({
    hasDataStream,
    storeCurrentStep,
    datasetConfigScope,
    scopeState,
    workspaceId
}) => {
    if (!hasDataStream) {
        return <>-</>;
    }

    if (storeCurrentStep !== EditorSteps.objects && !datasetConfigScope) {
        return <LoadingSpinner size={24} />;
    }

    return (
        <DataStreamObjectsSublabel
            scopeState={scopeState}
            scopeConfig={datasetConfigScope ?? []}
            workspaceId={workspaceId}
        />
    );
};

/**
 * Create an object representing the plugin import objects step.
 * This step is always disabled in the plugin import context.
 */
export const usePluginImportObjectsStep = ({
    hasDataStream,
    storeCurrentStep,
    datasetConfigScope,
    scopeState,
    workspaceId
}: UsePluginImportObjectsStepParameters): StepWithCondition<PluginImportObjectsStepSublabelProps> => {
    return {
        name: EditorSteps.objects,
        isEnabled: false, // Always disabled for plugin import
        Sublabel: PluginImportObjectsStepSublabel,
        sublabelProps: {
            hasDataStream,
            storeCurrentStep,
            datasetConfigScope,
            scopeState,
            workspaceId
        },
        Content: ObjectsStep,
        contentProps: {}
    };
};
